module.exports = __webpack_public_path__ + "img/bg2.41e312b7.jpg";